export default "__VITE_ASSET__f9715225__"